export default __webpack_public_path__ + "static/media/icon-edit-green.4f2d0774.svg";